import { VALID_UPC_REGEX, VALID_EAN_REGEX, VALID_ISBN_REGEX, VALID_GTIN_REGEX } from '../constants/threeLayer';

// Shared identifier-format check for the PO / vendor-item entry points that let a user type or
// upload a UPC/EAN/ISBN/GTIN. Several of these forms only checked string length (e.g. "12
// characters"), which a non-numeric code like a vendor SKU ("00SDT-123337") can satisfy by
// coincidence while not being a real UPC at all - this checks the actual digit pattern instead.
const IDENTIFIER_REGEX_MAP = {
  upc: VALID_UPC_REGEX,
  ean: VALID_EAN_REGEX,
  isbn: VALID_ISBN_REGEX,
  gtin: VALID_GTIN_REGEX,
};

// Returns null when acceptable (including when identifierType isn't one we validate here),
// otherwise a human-readable reason.
export const getIdentifierValidationError = (identifierType, identifierValue) => {
  const value = String(identifierValue ?? '').trim();
  if (!value) return 'Identifier value is required';

  const type = String(identifierType || '').trim().toLowerCase();
  const regex = IDENTIFIER_REGEX_MAP[type];
  if (!regex) return null;

  if (!regex.test(value)) {
    return `${type.toUpperCase()} must match the expected ${type.toUpperCase()} format`;
  }
  return null;
};

export const isValidIdentifier = (identifierType, identifierValue) =>
  getIdentifierValidationError(identifierType, identifierValue) === null;

export default getIdentifierValidationError;
